module.exports = __webpack_public_path__ + "static/media/doc.9fe2d20e.svg";